import { snakeCase } from 'lodash';
import { apolloClient } from '~/apollo-client';
import { UploadContext } from '~/machines/upload';
import {
  Flex_UploadLmiProofDocMutation,
  Flex_UploadLmiProofDocMutationVariables,
  LmiProofDocUploadDocumentType,
  LmiProofDocUploadRelationship,
} from '~/typings/graphql';
import { updateLmiDocName } from '~/utils/files';
import { UPLOAD_LMI_PROOF_DOC } from './upload-lmi-proof-doc.queries';

export type UploadLMIProofDocParams = {
  utilityAccountId: number;
  documentType: string;
  file: File;
  base64Image: string;
  proofType?: LmiProofDocUploadDocumentType;
  name?: string;
  relationship?: LmiProofDocUploadRelationship;
};

export const uploadLMIProofDoc = async ({
  utilityAccountId,
  documentType,
  file,
  base64Image,
  proofType,
  name,
  relationship,
}: UploadLMIProofDocParams): Promise<UploadContext['docs'][0]> => {
  let uploadedFile;
  try {
    const uploadId = await uploadDoc(
      utilityAccountId,
      documentType,
      base64Image,
      proofType || LmiProofDocUploadDocumentType.Unknown,
      name || '',
      relationship || LmiProofDocUploadRelationship.Self,
    );
    uploadedFile = Object.assign(file, { uploadId });
  } catch (e) {
    uploadedFile = Object.assign(file, { error: 'save-failed' });
  }
  return { documentType, image: uploadedFile } as UploadContext['docs'][0];
};

const uploadDoc = async (
  utilityAccountId: number,
  documentType: string,
  base64Image: string,
  proofType: LmiProofDocUploadDocumentType,
  name: string,
  relationship: LmiProofDocUploadRelationship,
) => {
  const response = await apolloClient.mutate<
    Flex_UploadLmiProofDocMutation,
    Flex_UploadLmiProofDocMutationVariables
  >({
    mutation: UPLOAD_LMI_PROOF_DOC,
    variables: {
      input: {
        utilityAccountId,
        documentType: snakeCase(updateLmiDocName(documentType)),
        image: base64Image,
        proofType,
        name,
        relationship,
      },
    },
  });
  return response.data?.uploadLMIProofDoc.id!;
};
